import { fetchTrades } from '../reducers/tradesReducer';
import { takeLatest } from 'redux-saga/effects';
import { createSaga } from '../utils/createSaga';

export default function* watch() {
  yield takeLatest(
    fetchTrades.TRIGGER,
    createSaga(fetchTrades, fetchTrades._PREFIX),
  );
}
